import Compass2 from 'vcomponents/pages/Compass2.vue';
import Feature from 'Services/Feature';

export default [
    {
        path: '/check-compass2',
        name: 'compass2',
        component: Compass2,
        beforeEnter(to, from, next) {
            if (!Feature.isEnabled('check-compass2')) {
                next({ name: 'error.not.found' });
            }
            next();
        },
    },
];
